import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const Panel = styled.div`
  > h1 {
    color: #6b6969;
    font-family: roboto sans-serif;
    -webkit-font-smoothing: antialiased;
    text-shadow: 1px 1px 1px rgba(0,0,0,.004);
    font-size: 84px;
    font-weight: 700;
    line-height: 1;
    margin: 0 0 25px;
  }
`

const NotFoundPage = ({ location }) => {
  return (
    <Panel>
      <h1>404</h1>
      <h2>A página {location.pathname} não existe!</h2>
      <p>
        <Link to="/" className="btn btn-primary">Voltar para a página inicial</Link>
      </p>
    </Panel>
  )
}

export default NotFoundPage
